import { View, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme/theme';

const style = StyleSheet.create({
  pdfTitleSectionStyle: {
    width: '100%',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  pdfLeasingTypeTitleStyle: {
    justifyContent: 'flex-end',
    marginTop: '20px',
    paddingRight: '15px',
    height: '30px',

    backgroundColor: theme.colors.primaryT2,
  },
});

export const PdfTitleContainer: React.FC<{
  isLeasingTypeTitle?: boolean;
}> = ({ isLeasingTypeTitle, ...props }) => (
  <View
    style={[
      style.pdfTitleSectionStyle,
      isLeasingTypeTitle ? style.pdfLeasingTypeTitleStyle : {},
    ]}>
    {props.children}
  </View>
);
